import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
import {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
    resetLiquidaciones,
    fetchResultadosLiquidaciones,
    updateLiquidaciones,
    updateEstadoLiquidacion,
    limpiarLiquidacionesBusqueda,
    updateEstadoListLiquidacion,
    fetchDetalleRetenciones,
    resetPercepcionRetencionLiquidacion,
    fetchCalcularPercepcionRetencion,
    actualizarTotalRetencionesOrdenes
} from '../../../../actions/LiquidacionesActions';
import {
    fetchExportarLiquidacionExcelApi,
    putEditaLiquidacion,
    putEliminaLiquidacionFinal,
    putConfirmarLiquidacion,
    getTipoComprobantesApi,
    fetchExportarRetencionesYPercepcionesApi,
    fetchExportarCertificadosPdfApi,
    postFacturarLiquidacionApi,
    postGenerarNotaDeCreditoApi
} from '../../../../api/axios.js';
import {
    extractApiErrorMessages,
    isRequestTimeoutLikeError,
    MESSAGE_LONG_OPERATION_STILL_PROCESSING
} from '../../../../utilities/apiErrors';
import { Modal, Button } from 'react-bootstrap';
import DetalleLiquidacionEditar, { getLiquidacionCampoNumerico, getTotalFactura, getTotalNotaCredito } from './DetalleLiquidacionEditar';
import OrdenesDeLiquidacionBorrador from './OrdenesDeLiquidacionBorrador';
import NovedadesDeLiquidacionBorrador from './NovedadesDeLiquidacionBorrador';
import LogisticaDeLiquidacion from './LogisticaDeLiquidacion';
import RebatesDeLiquidacion from "./RebatesDeLiquidacion";
import { toast } from '../../../../utilities/appToast';
import MiniSpinner from '../../../General/MiniSpinner';
import BigSpinner from '../../../General/BigSpinner';
import '../../shared/liquidacionesModule.css';
import { DropDownArrow, customStyle } from '../../../../template/CustomStyle';
import ModalDetallePercepciones from './ModalDetallePercepciones.js';
import ModalDetalleRetenciones from './ModalDetalleRetenciones.js';
import { FileArchive, FileSpreadsheet, FileText, Download, FileDown } from "lucide-react";

// Wrapper para usar hooks en class component
function EditarLiquidacionBorradorWrapper(props) {
    const navigate = useNavigate();
    const { id, idSeller } = useParams();
    const location = useLocation();
    return <EditarLiquidacionBorrador {...props} navigate={navigate} id={id} idSeller={idSeller} location={location} />;
}

const DETAIL_TAB_KEYS = {
    ordenes: 'ordenes',
    novedades: 'novedades',
    logistica: 'logistica',
    rebates: 'rebates',
};


class EditarLiquidacionBorrador extends Component {
    constructor(props) {
        super(props);
        this.idOrdenesSeleccionadas = React.createRef();
        this.idNovedadesSeleccionadas = React.createRef();
        this._confirmacionEnCurso = false;
        this._calculoEnCurso = false;
        this.state = {
            request: {
                idLiquidacion: parseInt(this.props.id),
                idSeller: parseInt(this.props.idSeller),
                borrador: 1
            },
            showSpinner: false,
            spinnerConfirmar: false,
            tipoFactura:
            {
                value: null,
                label: null
            },
            mostrarModalRetenciones: false,
            mostrarModalPercepciones: false,
            detalleOrdenes: [],
            detalleLiquidacion: [],
            showSpinnerCertificados: false,
            modoFacturacion: 'manual', // manual | automatica
            activeBillingTab: 'facturacion',
            tipoNotaCredito: {
                value: null,
                label: null
            },
            modoNotaCredito: 'manual', // manual | automatica
            tributosCalculados: false,
            calculandoTributos: false,
            activeDetailTab: DETAIL_TAB_KEYS.ordenes,
        }
    };

    handleBeforeUnloadWhileCalculando = (event) => {
        if (!this.state.calculandoTributos) return;
        event.preventDefault();
        event.returnValue = '';
    };

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleBeforeUnloadWhileCalculando);
        this.props.fetchLiquidacionporid(this.state.request);
        //this.setState({tipoFactura.value = this.props.liquidacion_por_id.IdTipoFactura})
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnloadWhileCalculando);
    }


    gestionarLiquidacion = async (event, idEstado) => {

        event.preventDefault();

        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden);

        if (idOrdenes.length === 0) {
            toast.warn("Seleccione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad);

        let data = {
            CuerpoOrdenes: idOrdenes,
            CuerpoNovedad: idNovedades,
            IdLiquidacion: this.state.request.idLiquidacion,
            IdEstado: idEstado
        }

        let post = putEditaLiquidacion(data);

        post.then(res => {
            toast.success("La liquidacion fue actualizada con exito.");
            this.props.resetLiquidaciones()
            this.props.navigate("/Liquidaciones");
        }).catch (err => {
            const errores = err?.response?.data?.errores;
            if (Array.isArray(errores))
                errores.forEach(error => toast.error(error.item2));
            else
                toast.error("No pudimos actualizar la liquidacion");
            this.props.navigate("/");
        });
    }

    formatNumeroComprobante = (input) => {
        const rawValue = input || "";
        // Solo dígitos y letras, sin guiones ni otros caracteres
        const limpio = rawValue.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();

        const parte1 = limpio.slice(0, 4);
        const parte2 = limpio.slice(4, 12);
        const parte3 = limpio.slice(12, 13);

        let formateado = parte1;
        if (limpio.length > 4) {
            formateado += "-" + parte2;
        }
        if (limpio.length > 12) {
            formateado += "-" + parte3;
        }

        return formateado;
    };

    handleNumeroFacturaChange = (e) => {
        this.setState({ numeroFactura: this.formatNumeroComprobante(e.target.value || '') });
    };

    handleNotaCreditoNumeroChange = (e) => {
        this.setState({ notaCreditoNumeroFactura: this.formatNumeroComprobante(e.target.value || '') });
    };

    validarNumeroComprobante = (numero, mensajePrefijo = "El Número de Comprobante") => {
        if (!numero) {
            toast.warn("Debe ingresar un Numero de Factura.");
            return false;
        }
        const formatoValido = /^\d{4}-\d{8}-[A-Z]$/;
        if (!formatoValido.test(numero)) {
            toast.warn(`${mensajePrefijo} debe tener el formato 0000-00000000-X (4 dígitos, guion, 8 dígitos, guion y una letra).`);
            return false;
        }
        return true;
    };

    /** Número de NC que viene del detalle de liquidación (ConsultarDetalleLiquidacion), sin pisar con el de factura. */
    getNumeroComprobanteNotaCreditoDesdeLiquidacion = (liq) => {
        if (!liq || typeof liq !== 'object') return undefined;
        const raw =
            liq.numeroComprobanteNotaCredito ??
            liq.NumeroComprobanteNotaCredito ??
            liq.numeroNotaCredito ??
            liq.NumeroNotaCredito;
        if (raw == null || String(raw).trim() === '') return undefined;
        return this.formatNumeroComprobante(String(raw));
    };

    getIdTipoComprobanteNotaCreditoDesdeLiquidacion = (liq) => {
        if (!liq || typeof liq !== 'object') return undefined;
        const v = liq.idTipoComprobanteNotaCredito ?? liq.IdTipoComprobanteNotaCredito;
        if (v == null || v === '') return undefined;
        const n = typeof v === 'number' ? v : parseInt(String(v), 10);
        return Number.isFinite(n) ? n : undefined;
    };

    getDescripcionTipoComprobanteNotaCreditoDesdeLiquidacion = (liq) => {
        if (!liq || typeof liq !== 'object') return undefined;
        const d =
            liq.descripcionTipoComprobanteNotaCredito ??
            liq.DescripcionTipoComprobanteNotaCredito ??
            liq.descripcionTipoNotaCredito ??
            liq.DescripcionTipoNotaCredito;
        return d != null && String(d).trim() !== '' ? String(d) : undefined;
    };

    getCodigoSapNotaCreditoDesdeLiquidacion = (liq) => {
        if (!liq || typeof liq !== 'object') return undefined;
        const c =
            liq.codigoSapNotaCredito ??
            liq.CodigoSapNotaCredito ??
            liq.codigoSAPNotaCredito ??
            liq.CodigoSAPNotaCredito;
        return c != null && String(c).trim() !== '' ? String(c) : undefined;
    };

    notificarErrorConfirmacionLiquidacion = (err) => {
        if (isRequestTimeoutLikeError(err)) {
            toast.warn(MESSAGE_LONG_OPERATION_STILL_PROCESSING);
            return;
        }
        extractApiErrorMessages(err).forEach((m) => toast.error(m));
    };

    ejecutarConfirmacion = async (event) => {
        if (this._confirmacionEnCurso) return;

        event?.preventDefault?.();

        const { request, modoFacturacion, modoNotaCredito, numeroFactura, tipoFactura, codigoSAP, notaCreditoNumeroFactura, tipoNotaCredito } = this.state;

        const liquidacion = this.props.liquidacion_por_id || {};
        const tieneDevolucion = getTotalNotaCredito(liquidacion) !== 0;
        const totalFacturaEsCero = getTotalFactura(liquidacion) === 0;

        const numeroNcDesdeDetalle = this.getNumeroComprobanteNotaCreditoDesdeLiquidacion(liquidacion);
        const idTipoNcDesdeDetalle = this.getIdTipoComprobanteNotaCreditoDesdeLiquidacion(liquidacion);
        const numeroNcEfectivo = notaCreditoNumeroFactura ?? numeroNcDesdeDetalle;
        const idTipoNcEfectivo = tipoNotaCredito?.value ?? idTipoNcDesdeDetalle;

        // Validaciones manuales (si corresponde)
        if (!totalFacturaEsCero && modoFacturacion === 'manual') {
            if (!this.validarNumeroComprobante(numeroFactura, "El Número de Factura")) return;
            if (!tipoFactura?.value) {
                toast.warn("Debe seleccionar un Tipo de Factura.");
                return;
            }
        }

        if (tieneDevolucion && modoNotaCredito === 'manual') {
            if (!this.validarNumeroComprobante(numeroNcEfectivo, "El Número de Nota de Crédito")) return;
            if (idTipoNcEfectivo == null || idTipoNcEfectivo === '') {
                toast.warn("Debe seleccionar un Tipo de Nota de Crédito.");
                return;
            }
        }

        this._confirmacionEnCurso = true;
        this.setState({ spinnerConfirmar: true });
        try {
            // Si hay nota de crédito y es automática, primero la generamos
            if (tieneDevolucion && modoNotaCredito === 'automatica') {
                try {
                    await postGenerarNotaDeCreditoApi({ idLiqui: request.idLiquidacion });
                } catch (err) {
                    this.notificarErrorConfirmacionLiquidacion(err);
                    return;
                }
            }

            if (totalFacturaEsCero) {
                if (tieneDevolucion && modoNotaCredito === 'manual') {
                    await putConfirmarLiquidacion({
                        IdLiquidacion: request.idLiquidacion,
                        NumeroComprobanteNotaCredito: numeroNcEfectivo,
                        IdTipoComprobanteNotaCredito: idTipoNcEfectivo,
                    });
                }

                try {
                    await postFacturarLiquidacionApi({ idLiquidacion: request.idLiquidacion });
                    toast.success("Liquidacion facturada automáticamente y confirmada exitosamente.");
                    this.props.resetLiquidaciones();
                    this.props.navigate("/Liquidaciones");
                    return;
                } catch (err) {
                    this.notificarErrorConfirmacionLiquidacion(err);
                    return;
                }
            }

            if (modoFacturacion === 'automatica') {
                try {
                    await postFacturarLiquidacionApi({ idLiquidacion: request.idLiquidacion });
                    toast.success("Liquidacion facturada automáticamente y confirmada exitosamente.");
                    this.props.resetLiquidaciones();
                    this.props.navigate("/Liquidaciones");
                    return;
                } catch (err) {
                    this.notificarErrorConfirmacionLiquidacion(err);
                    return;
                }
            }

            // Confirmación manual
            let data = {
                IdLiquidacion: request.idLiquidacion,
                NumeroComprobante: numeroFactura,
                IdTipoComprobante: tipoFactura.value,
                codigoSAP: parseInt(codigoSAP),
                // Nota de crédito (solo si corresponde y es manual)
                NumeroComprobanteNotaCredito: (tieneDevolucion && modoNotaCredito === 'manual') ? numeroNcEfectivo : null,
                IdTipoComprobanteNotaCredito: (tieneDevolucion && modoNotaCredito === 'manual') ? idTipoNcEfectivo : null,
            };

            await putConfirmarLiquidacion(data);
            toast.success("La liquidacion fue confirmada con exito.");

            const liquidacionEstadoActualizado = {
                ...this.props.liquidacion_por_id,
                numeroComprobante: numeroFactura,
                idTipoFactura: tipoFactura.value,
                descripcionTipoFactura: tipoFactura.label,
                codigoSap: parseInt(codigoSAP),
                idTipoEstadoLiquidacion: 3 // Confirmado
            };

            this.props.updateEstadoLiquidacion(liquidacionEstadoActualizado);
            this.props.updateEstadoListLiquidacion(this.props.liquidaciones, liquidacionEstadoActualizado.idLiquidacion);
        } catch (err) {
            this.notificarErrorConfirmacionLiquidacion(err);
        } finally {
            this.setState({ spinnerConfirmar: false });
            this._confirmacionEnCurso = false;
        }
    };

    editarBorrador = (event) => {
        this.gestionarLiquidacion(event, 2);
    }


    eliminarLiquidacion = (idLiquidacion) => {
        let request = { IdLiquidacion: idLiquidacion };

        putEliminaLiquidacionFinal(request)
            .then(res => {
                this.props.updateLiquidaciones(this.props.liquidaciones, idLiquidacion)
                toast.success("La liquidacion fue eliminada con exito");
                this.props.navigate("/Liquidaciones");
            })
            .catch(err => {
                const errores = err?.response?.data?.errores;
                if (Array.isArray(errores))
                    errores.forEach(error => toast.error(error.item2));
                else
                    toast.error("No pudo eliminarse");
            });
    };

    getApiErrorItems = (err) => {
        const data = err?.response?.data;
        const errores = Array.isArray(data)
            ? data
            : (Array.isArray(data?.errores) ? data.errores : []);

        return errores
            .map((error) => error?.item2 ?? error?.Item2 ?? error?.item1 ?? error?.Item1)
            .filter(Boolean);
    };

    descargarExcelBorradorLiquidaciones = async (id, razonSocialSeller) => {
        this.setState({
            showSpinner: true
        });

        try {
            let res = await fetchExportarLiquidacionExcelApi(id);

            let resBase64 = res.excel;

            if (resBase64) {
                const byteCharacters = atob(resBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const razonSocialLimpia = razonSocialSeller.replace(/[^a-zA-Z0-9_]/g, "_");
                const fileName = `${razonSocialLimpia}_Liquidacion_Numero_${id}.xlsx`;
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.error("Error al generar el archivo.");
            }
        } catch (err) {
            const errores = err?.response?.data?.errores;

            if (Array.isArray(errores))
                errores.forEach(error => toast.error(error.item2));
            else
                toast.error("No pudo descargarse el archivo");
        } finally {
            this.setState({
                showSpinner: false
            });
        }
    }

    async exportarRetencionesYPercepciones(id, razonSocial) {
        try {
            let res = await fetchExportarRetencionesYPercepcionesApi(id)

            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                let razonSocialSeller = razonSocial.replace(/[^a-zA-Z0-9]/g, "_");
                let fileName = `retencionesYPercepciones_${razonSocialSeller}.zip`;

                this.descargarZip(base64Zip, fileName);
            } else {
                toast.error("No se pudo generar el archivo .zip.");
            }
        } catch (err) {
            const errores = this.getApiErrorItems(err);

            if (errores.length > 0)
                errores.forEach((error) => toast.error(error));
            else
                toast.error("No pudo descargarse el archivo .zip");
        }
    }

    descargarZip(base64, fileName) {
        // Convertir Base64 a Blob
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/zip" });

        // Crear URL y descargar
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    }

    handleOpenTipoFactura = () => {

        getTipoComprobantesApi().then(response => {

            const opciones = response.data.tipoComprobantes?.map(item => ({
                value: item.idTipoComprobante,
                label: item.descripcion
            })) || [];

            this.setState({ opcionesTipoFactura: opciones });
        });
    };

    normalizeTipoComprobanteLabel = (label) => String(label ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase();

    getTipoComprobanteOptions = (prefix) => {
        const normalizedPrefix = this.normalizeTipoComprobanteLabel(prefix);

        return (this.state.opcionesTipoFactura || []).filter(option =>
            this.normalizeTipoComprobanteLabel(option.label).startsWith(normalizedPrefix)
        );
    };

    renderFacturacionFields = ({
        title,
        numeroField,
        numeroLabel = 'NUMERO DE FACTURA',
        numeroValue,
        tipoLabel = 'TIPO DE FACTURA',
        tipoOptions,
        tipoField,
        tipoValue,
        fallbackTipoValue,
        codigoSapValue,
        onNumeroChange,
        onCodigoSapChange,
        showCodigoSap = true,
        isDisabled,
        switchDisabled = isDisabled,
        billingMode,
    }) => {
        const esFacturacion = billingMode === 'facturacion';
        const esAutomatica = esFacturacion
            ? this.state.modoFacturacion === 'automatica'
            : this.state.modoNotaCredito === 'automatica';
        const camposDeshabilitados = isDisabled || esAutomatica;

        return (
        <div className="pt-3">
            <div className="d-flex justify-content-between align-items-center mb-3 liquidacion-borrador-billing-header">
                <h6 className="card-subtitle mb-0 text-muted text-uppercase fw-bold" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                    {title}
                </h6>

                <div className="d-flex align-items-center gap-2">
                    <span className="text-muted small">
                        {esAutomatica ? 'Automática' : 'Manual'}
                    </span>
                    <div className="form-check form-switch m-0">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`${numeroField}-modo-switch`}
                            checked={esAutomatica}
                            onChange={(e) => {
                                const automatica = e.target.checked;
                                const modo = automatica ? 'automatica' : 'manual';
                                if (esFacturacion) {
                                    this.setState({ modoFacturacion: modo });
                                } else {
                                    this.setState({ modoNotaCredito: modo });
                                }
                            }}
                            disabled={switchDisabled}
                        />
                    </div>
                </div>
            </div>
            <div className="row g-3">
                <div className="col-12">
                    <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>{numeroLabel}</label>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text bg-light border-end-0">
                            <i className="fa fa-hashtag text-muted"></i>
                        </span>
                        <input
                            type="text"
                            name={numeroField}
                            className="form-control border-start-0 ps-0"
                            value={numeroValue}
                            onChange={onNumeroChange}
                            placeholder="Ej: 0001-00001234-A"
                            disabled={camposDeshabilitados}
                        />
                    </div>
                </div>

                <div className="col-12">
                    <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>{tipoLabel}</label>
                    <Select
                        name={tipoField}
                        value={tipoValue?.value ? tipoValue : fallbackTipoValue}
                        options={tipoOptions}
                        onChange={this.selectSearchHandler}
                        components={{ DropdownIndicator: () => DropDownArrow }}
                        styles={customStyle}
                        onMenuOpen={this.handleOpenTipoFactura}
                        isDisabled={camposDeshabilitados}
                        placeholder="Seleccionar..."
                    />
                </div>

                {showCodigoSap && (
                    <div className="col-12">
                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>CODIGO SAP</label>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-light border-end-0">
                                <i className="fa fa-barcode text-muted"></i>
                            </span>
                            <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                value={codigoSapValue}
                                onChange={onCodigoSapChange}
                                placeholder="Ingrese Código SAP"
                                disabled={camposDeshabilitados}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
        );
    };

    parseCalculoPercepcionRetencionResponse(res) {
        const payload = res?.data ?? res ?? {};
        const toNumber = (value) => {
            const n = typeof value === 'number' ? value : Number(String(value ?? '').replace(',', '.'));
            return Number.isFinite(n) ? n : 0;
        };

        return {
            totalRetenciones: toNumber(payload.totalRetenciones ?? payload.TotalRetenciones),
            totalPercepcion: toNumber(payload.totalPercepcion ?? payload.TotalPercepcion),
            retenciones: payload.retenciones ?? payload.Retenciones ?? [],
        };
    }

    async calcularPercepcionRetencion(idLiquidacion) {
        if (this._calculoEnCurso || this.state.calculandoTributos) return;

        this._calculoEnCurso = true;
        this.setState({ calculandoTributos: true });

        const request = { idLiquidacion };

        try {
            const res = await this.props.fetchCalcularPercepcionRetencion(request);
            const { totalRetenciones, totalPercepcion, retenciones } = this.parseCalculoPercepcionRetencionResponse(res);

            const liquidacion = this.props.liquidacion_por_id || {};
            const oldTotalPercepcion = Number(liquidacion.totalPercepcion ?? liquidacion.TotalPercepcion ?? 0) || 0;
            const oldTotalFacturar = Number(liquidacion.totalFacturar ?? liquidacion.TotalFacturar ?? 0) || 0;
            const deltaPercepcion = totalPercepcion - oldTotalPercepcion;
            const newTotalFacturar = oldTotalFacturar + deltaPercepcion;

            this.props.updateEstadoLiquidacion({
                ...liquidacion,
                totalRetenciones,
                totalPercepcion,
                totalFacturar: newTotalFacturar,
            });

            this.props.actualizarTotalRetencionesOrdenes(retenciones, this.props.cuerpoOrdenLiquidaciones);
            this.setState({ tributosCalculados: true });
        } catch (err) {
            const errores = err?.response?.data?.errores;

            if (Array.isArray(errores))
                errores.forEach(error => toast.error(error.item2));
            else if (isRequestTimeoutLikeError(err))
                toast.warn(MESSAGE_LONG_OPERATION_STILL_PROCESSING);
            else
                toast.error("No pudo calcularse");
        } finally {
            this._calculoEnCurso = false;
            this.setState({ calculandoTributos: false });
        }
    }



    verDetalleRetencionesPercepciones = (id, origen = "orden") => {

        const { detalleTributarioOrdenes, detalleTributarioLiquidacion } = this.props;
        const idLiquidacion = this.props.liquidacion_por_id.idLiquidacion;

        const yaTienePercepciones = origen === "liquidacion" && detalleTributarioLiquidacion?.length > 0;
        const yaTieneRetenciones = origen === "orden" && detalleTributarioOrdenes?.some(o => o.id === id);

        if ((origen === "liquidacion" && yaTienePercepciones) || (origen === "orden" && yaTieneRetenciones)) {
            this.setState({
                mostrarModalPercepciones: origen === "liquidacion",
                mostrarModalRetenciones: origen === "orden",
                ordenIdSeleccionado: origen === "orden" ? id : null
            });
            return;
        }

        // Solo entra acá si no tiene datos aún
        this.props.fetchDetalleRetenciones(idLiquidacion, origen, id);

        this.setState({
            mostrarModalPercepciones: origen === "liquidacion",
            mostrarModalRetenciones: origen === "orden",
            ordenIdSeleccionado: origen === "orden" ? id : null
        });
    };




    cerrarModalRetenciones = () => {
        this.setState({ mostrarModalRetenciones: false });
    };


    handleVerDetallePercepciones = () => {
        this.setState({ mostrarModalPercepciones: true });
    };

    handleCerrarModalPercepciones = () => {
        this.setState({ mostrarModalPercepciones: false });
    };

    async exportarCertificadosPdf(id) {
        this.setState({ showSpinnerCertificados: true });

        try {
            let res = await fetchExportarCertificadosPdfApi(id);
            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                this.descargarZip(base64Zip, "certificadosPdf.zip");
            } else {
                toast.error("No se pudo generar el archivo ZIP.");
            }
        } catch (err) {
            const errores = this.getApiErrorItems(err);

            if (errores.length > 0)
                errores.forEach((error) => toast.error(error));
            else
                toast.error("No pudo descargarse el archivo .zip");
        } finally {
            this.setState({ showSpinnerCertificados: false });
        }
    }

    render() {
        const contaduria = 8;
        let isCategory = 1;
        let isAdminMod = 2;
        let isSellerAdmin = 3;
        let isSeller = 4;

        const { tipoUsuario, liquidacion_por_id } = this.props;
        const { ordenIdSeleccionado } = this.state;

        const detalleFiltrado = Array.isArray(this.props.detalleTributarioOrdenes)
            ? this.props.detalleTributarioOrdenes.filter(o => o.id === ordenIdSeleccionado)
            : [];

        const isConfirmada = liquidacion_por_id?.idTipoEstadoLiquidacion === 3;

        // Determina si hay valores de retenciones o percepciones
        const tieneValoresCalculados = this.state.tributosCalculados
            || getLiquidacionCampoNumerico(liquidacion_por_id, 'totalRetenciones') > 0
            || getLiquidacionCampoNumerico(liquidacion_por_id, 'totalPercepcion') > 0;

        // Si es Contaduria o Category, verificamos si está calculado para habilitar campos/botones
        // Si no tiene valores calculados, se bloquea el resto y solo deja Calcular
        const esUsuarioRestringido = (tipoUsuario === contaduria || tipoUsuario === isCategory);

        // Bloqueo general si está cargando
        const bloqueoPorCarga = this.state.showSpinner || this.state.spinnerConfirmar || this.state.calculandoTributos;
        const accionesDescargaHabilitadas = isConfirmada || tieneValoresCalculados;
        const mensajeBloqueo = "No se encuentra calculada la percepcion y retencion";
        const tieneDevolucion = getTotalNotaCredito(liquidacion_por_id) !== 0;
        const tieneFactura = getTotalFactura(liquidacion_por_id) !== 0;
        const billingTabs = [
            ...(tieneFactura ? [{ key: 'facturacion', label: 'Datos de Facturación' }] : []),
            ...(tieneDevolucion ? [{ key: 'nota-credito', label: 'Nota de Crédito' }] : []),
        ];
        const activeBillingTab = billingTabs.some(tab => tab.key === this.state.activeBillingTab)
            ? this.state.activeBillingTab
            : billingTabs[0]?.key;
        const camposBloqueados = isConfirmada || !tieneValoresCalculados;
        const facturaFallbackTipo = {
            value: this.props.liquidacion_por_id?.idTipoFactura ?? '',
            label: this.props.liquidacion_por_id?.descripcionTipoFactura ?? 'Seleccionar...'
        };
        const idTipoNcEnc = this.getIdTipoComprobanteNotaCreditoDesdeLiquidacion(liquidacion_por_id);
        const descTipoNcEnc = this.getDescripcionTipoComprobanteNotaCreditoDesdeLiquidacion(liquidacion_por_id);
        const notaCreditoFallbackTipo = {
            value: idTipoNcEnc ?? '',
            label: descTipoNcEnc ?? 'Seleccionar...'
        };
        const facturaOptions = this.getTipoComprobanteOptions('FACTURAS');
        const notaCreditoOptions = this.getTipoComprobanteOptions('NOTAS DE CREDITO');
        const detailTabs = [
            {
                key: DETAIL_TAB_KEYS.ordenes,
                label: 'Órdenes',
                count: this.props.cuerpoOrdenLiquidaciones?.length ?? 0,
                content: (
                    <OrdenesDeLiquidacionBorrador
                        isLoading={this.props.isLoadingDetalleLiquidacion}
                        ordenes={this.props.cuerpoOrdenLiquidaciones}
                        ref={this.idOrdenesSeleccionadas}
                        liquidacion={this.props.liquidacion_por_id}
                        onVerDetalleRetenciones={this.verDetalleRetencionesPercepciones}
                        onOrdenesAgregadas={() => this.props.fetchLiquidacionporid(this.state.request)}
                    />
                )
            },
            {
                key: DETAIL_TAB_KEYS.novedades,
                label: 'Novedades',
                count: this.props.cuerpoNovedadLiquidaciones?.length ?? 0,
                content: (
                    <NovedadesDeLiquidacionBorrador
                        isLoading={this.props.isLoadingDetalleLiquidacion}
                        novedades={this.props.cuerpoNovedadLiquidaciones}
                        ref={this.idNovedadesSeleccionadas}
                    />
                )
            },
            {
                key: DETAIL_TAB_KEYS.logistica,
                label: 'Fee Logístico',
                count: this.props.cuerpoFeeLogisticoLiquidaciones?.length ?? 0,
                content: (
                    <LogisticaDeLiquidacion
                        isLoading={this.props.isLoadingDetalleLiquidacion}
                        logistica={this.props.cuerpoFeeLogisticoLiquidaciones}
                    />
                )
            },
            {
                key: DETAIL_TAB_KEYS.rebates,
                label: 'Rebates',
                count: (this.props.detalleRebate ?? []).reduce(
                    (total, detalle) => total + (detalle?.listRebates?.length ?? 0),
                    0
                ),
                content: (
                    <RebatesDeLiquidacion
                        detalleRebate={this.props.detalleRebate}
                        isLoading={this.props.isLoadingDetalleLiquidacion}
                    />
                )
            },
        ];

        return (
            <div className="container" style={{ pointerEvents: bloqueoPorCarga ? 'none' : 'auto', opacity: bloqueoPorCarga ? 0.6 : 1 }}>

                {this.state.calculandoTributos && (
                    <div
                        style={{
                            position: 'fixed',
                            inset: 0,
                            backgroundColor: 'rgba(15, 23, 42, 0.5)',
                            zIndex: 10000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'all',
                        }}
                        role="alertdialog"
                        aria-modal="true"
                        aria-busy="true"
                        aria-label="Calculando percepción y retención"
                    >
                        <BigSpinner message="Calculando percepción y retención. Este proceso puede tardar varios minutos. No cierre esta ventana hasta que finalice." />
                    </div>
                )}

                {bloqueoPorCarga && !this.state.calculandoTributos && (
                    <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
                        <MiniSpinner />
                    </div>
                )}

                <div>
                    <input type="hidden" id="valores_ordenes_editar"></input>
                    <input type="hidden" id="valores_novedades_editar"></input>
                </div>

                <DetalleLiquidacionEditar
                    liquidacion={this.props.liquidacion_por_id}
                    isBorrador={true}
                    VerDetallePercepciones={this.handleVerDetallePercepciones}
                    onVerDetallePercepciones={this.verDetalleRetencionesPercepciones}
                    onVolver={() => {
                        this.props.resetPercepcionRetencionLiquidacion();
                        window.history.go(-1);
                    }}
                >
                    {(tipoUsuario === contaduria || tipoUsuario === isCategory) && (tieneFactura || tieneDevolucion) && (
                        <div className="card mt-3 border-0 shadow-sm">
                            <div className="card-body p-3">
                                <ul className="nav nav-tabs border-0 gap-2 mb-0" role="tablist">
                                    {billingTabs.map(tab => (
                                        <li key={tab.key} className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className={`nav-link rounded-top px-3 py-2 ${activeBillingTab === tab.key ? 'active fw-semibold' : 'text-muted'}`}
                                                onClick={() => this.setState({ activeBillingTab: tab.key })}
                                                style={{
                                                    border: activeBillingTab === tab.key ? '1px solid #dee2e6' : '1px solid transparent',
                                                    borderBottom: activeBillingTab === tab.key ? '1px solid #fff' : '1px solid transparent',
                                                    backgroundColor: activeBillingTab === tab.key ? '#fff' : '#f8f9fa'
                                                }}
                                            >
                                                {tab.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                {activeBillingTab === 'facturacion'
                                    ? this.renderFacturacionFields({
                                        title: 'Datos de Facturación',
                                        numeroField: 'numeroFactura',
                                        numeroValue: this.state.numeroFactura ?? this.props.liquidacion_por_id?.numeroComprobante ?? '',
                                        numeroLabel: 'NUMERO DE FACTURA',
                                        tipoLabel: 'TIPO DE FACTURA',
                                        tipoOptions: facturaOptions,
                                        tipoField: 'tipoFactura',
                                        tipoValue: this.state.tipoFactura,
                                        fallbackTipoValue: facturaFallbackTipo,
                                        codigoSapValue: this.state.codigoSAP ?? this.props.liquidacion_por_id?.codigoSap ?? '',
                                        onNumeroChange: this.handleNumeroFacturaChange,
                                        onCodigoSapChange: (e) => this.setState({ codigoSAP: e.target.value }),
                                        showCodigoSap: true,
                                        billingMode: 'facturacion',
                                        isDisabled: camposBloqueados,
                                        switchDisabled: camposBloqueados,
                                    })
                                    : this.renderFacturacionFields({
                                        title: 'Nota de Crédito',
                                        numeroField: 'notaCreditoNumeroFactura',
                                        numeroValue: this.state.notaCreditoNumeroFactura ?? this.getNumeroComprobanteNotaCreditoDesdeLiquidacion(this.props.liquidacion_por_id) ?? '',
                                        numeroLabel: 'NUMERO NOTA DE CREDITO',
                                        tipoLabel: 'TIPO NOTA DE CREDITO',
                                        tipoOptions: notaCreditoOptions,
                                        tipoField: 'tipoNotaCredito',
                                        tipoValue: this.state.tipoNotaCredito,
                                        fallbackTipoValue: notaCreditoFallbackTipo,
                                        codigoSapValue: this.state.codigoSAPNotaCredito ?? this.getCodigoSapNotaCreditoDesdeLiquidacion(this.props.liquidacion_por_id) ?? '',
                                        onNumeroChange: this.handleNotaCreditoNumeroChange,
                                        onCodigoSapChange: (e) => this.setState({ codigoSAPNotaCredito: e.target.value }),
                                        showCodigoSap: false,
                                        billingMode: 'nota-credito',
                                        isDisabled: camposBloqueados,
                                        switchDisabled: isConfirmada,
                                    })}
                            </div>
                        </div>
                    )}
                </DetalleLiquidacionEditar>


                <div className="d-flex justify-content-between align-items-center my-4 liquidacion-borrador-actions">

                    {/* Grupo Izquierdo: Exportaciones (solo iconos) */}
                    <div className="d-flex gap-2 align-items-center">
                        {(tipoUsuario === isCategory || tipoUsuario === isAdminMod || tipoUsuario === contaduria) && (
                            <>
                                {/* Boton Certificados PDF */}
                                <button
                                    type="button"
                                    title="Descargar Certificados PDF"
                                    className={`btn btn-sm shadow fw-medium d-flex align-items-center justify-content-center ${accionesDescargaHabilitadas ? 'gestion-liquidaciones-btn-guardar' : 'gestion-liquidaciones-btn-limpiar'}`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() => this.exportarCertificadosPdf(this.props.liquidacion_por_id.idLiquidacion)}
                                    disabled={!accionesDescargaHabilitadas || this.state.showSpinnerCertificados}
                                >
                                    {this.state.showSpinnerCertificados ? <MiniSpinner size={14} /> : <FileText size={18} />}
                                </button>


                                {/* Boton Retenciones y Percepciones */}
                                <button
                                    title="Descargar Retenciones y Percepciones"
                                    disabled={!accionesDescargaHabilitadas || this.state.showSpinner}
                                    onClick={() => this.exportarRetencionesYPercepciones(
                                        this.props.liquidacion_por_id.idLiquidacion,
                                        this.props.liquidacion_por_id.razonSocialSeller
                                    )}
                                    className={`btn btn-sm shadow fw-medium d-flex align-items-center justify-content-center ${accionesDescargaHabilitadas ? 'gestion-liquidaciones-btn-guardar' : 'gestion-liquidaciones-btn-limpiar'}`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                >
                                    <Download size={18} />
                                </button>

                                {/* Boton Exportar Excel */}
                                <button
                                    title="Exportar a Excel"
                                    className={`btn btn-sm gestion-liquidaciones-btn-guardar d-flex align-items-center justify-content-center`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() =>
                                        this.descargarExcelBorradorLiquidaciones(
                                            this.props.liquidacion_por_id.idLiquidacion,
                                            this.props.liquidacion_por_id.razonSocialSeller
                                        )
                                    }
                                    disabled={this.state.showSpinner}
                                >
                                    {this.state.showSpinner ? <MiniSpinner size={14} /> : <FileSpreadsheet size={18} />}
                                </button>
                            </>
                        )}
                    </div>

                    {/* Grupo Derecho: Acciones de Liquidación (Texto) */}
                    <div className="d-flex gap-2 align-items-center">
                        {!isConfirmada && (
                            <>
                                {(tipoUsuario === contaduria || tipoUsuario === isSeller || tipoUsuario === isCategory) && (
                                    this.state.calculandoTributos ? <MiniSpinner /> :
                                        <button
                                            type="button"
                                            className="btn btn-sm gestion-liquidaciones-btn-guardar"
                                            disabled={this.state.calculandoTributos}
                                            onClick={() => this.calcularPercepcionRetencion(this.props.liquidacion_por_id.idLiquidacion)}
                                        >
                                            Calcular Percepción y Retención
                                        </button>
                                )}

                                {!(tipoUsuario === contaduria) && (
                                    <button
                                        title="Eliminar Liquidacion"
                                        type="button"
                                        className="btn btn-sm gestion-liquidaciones-btn-limpiar"
                                        onClick={() => this.eliminarLiquidacion(this.state.request.idLiquidacion)}
                                    >
                                        Anulacion Liquidacion
                                    </button>
                                )}

                                {(tipoUsuario === 1 || tipoUsuario === 2) && (
                                    <form className="form-horizontal form-material m-0" onSubmit={this.editarBorrador}>
                                        <button id="botonBorrador" type="submit" className="btn btn-sm gestion-liquidaciones-btn-limpiar">
                                            Guardar Borrador
                                        </button>
                                    </form>
                                )}
                            </>
                        )}

                        {/* Boton Confirmar Liquidacion - Visible solo si NO está confirmada, para Contaduria o Category */}
                        {!isConfirmada && (tipoUsuario === contaduria || tipoUsuario === isCategory) && (
                            this.state.spinnerConfirmar ? (
                                <MiniSpinner />
                            ) : (
                                <form className="form-horizontal form-material m-0" onSubmit={(e) => {
                                    e.preventDefault();
                                    this.ejecutarConfirmacion(e);
                                }}>
                                    <button
                                        disabled={this.state.showSpinner || !tieneValoresCalculados}
                                        id="botonLiquidada"
                                        type="submit"
                                        className={`btn btn-sm shadow fw-medium ${!tieneValoresCalculados ? 'gestion-liquidaciones-btn-limpiar' : 'gestion-liquidaciones-btn-guardar'}`}
                                    >
                                        Confirmar Liquidacion
                                    </button>
                                </form>
                            )
                        )}
                    </div>

                </div>

                <div className="liquidacion-detalle-tabs card mt-4 border-0 shadow-sm">
                    <div className="card-body p-3 p-lg-4">
                        <div className="liquidacion-detalle-tabs__nav" role="tablist" aria-label="Detalles de la liquidación">
                            {detailTabs.map((tab) => {
                                const isActive = this.state.activeDetailTab === tab.key;

                                return (
                                    <button
                                        key={tab.key}
                                        type="button"
                                        role="tab"
                                        aria-selected={isActive}
                                        className={`liquidacion-detalle-tabs__button ${isActive ? 'liquidacion-detalle-tabs__button--active' : ''}`}
                                        onClick={() => this.setState({ activeDetailTab: tab.key })}
                                    >
                                        <span>{tab.label}</span>
                                        <span className="liquidacion-detalle-tabs__count">{tab.count}</span>
                                    </button>
                                );
                            })}
                        </div>

                        <div className="liquidacion-detalle-tabs__content">
                            {detailTabs.map((tab) => {
                                const isActive = this.state.activeDetailTab === tab.key;

                                return (
                                    <div
                                        key={tab.key}
                                        role="tabpanel"
                                        hidden={!isActive}
                                        className={`liquidacion-detalle-tabs__panel ${isActive ? 'liquidacion-detalle-tabs__panel--active' : ''}`}
                                    >
                                        {tab.content}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <ModalDetallePercepciones
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                    show={this.state.mostrarModalPercepciones}
                    onHide={this.handleCerrarModalPercepciones}
                    percepciones={this.props.detalleTributarioLiquidacion}
                />

                <ModalDetalleRetenciones
                    show={this.state.mostrarModalRetenciones && !this.props.isLoadingDetalleLiquidacion}
                    onHide={this.cerrarModalRetenciones}
                    detalle={detalleFiltrado}
                    isLoading={this.props.isLoadingDetalleRetenciones}
                />

            </div >
        );
    }
}


const mapStateToProps = state => ({
    isLoadingDetalleLiquidacion: state.liquidaciones.isLoadingDetalleLiquidacion,
    liquidacion_por_id: state.liquidaciones.liquidacion_por_id,
    liquidacion_por_id_ordenes: state.liquidaciones.liquidacion_por_id_ordenes,
    liquidacion_por_id_novedades: state.liquidaciones.liquidacion_por_id_novedades,
    liquidacion_por_id_logistica: state.liquidaciones.liquidacion_por_id_logistica,
    lista_resultados_liquidaciones: state.liquidaciones.lista_resultados_liquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    tipoUsuario: state.general.tipoUsuario,
    cuerpoOrdenLiquidaciones: state.liquidaciones.cuerpoOrdenLiquidaciones || [],
    cuerpoFeeLogisticoLiquidaciones: state.liquidaciones.cuerpoFeeLogisticoLiquidaciones || [],
    cuerpoNovedadLiquidaciones: state.liquidaciones.cuerpoNovedadLiquidaciones || [],
    detalleRebate: state.liquidaciones.detalleRebate || [],
    detalleTributarioOrdenes: state.liquidaciones.detalleTributarioOrdenes || [],
    detalleTributarioLiquidacion: state.liquidaciones.detalleTributarioLiquidacion || [],
    percepcionRetencionLiquidacion: state.liquidaciones.percepcionRetencionLiquidacion || {},
    isLoadingDetalleRetenciones: state.liquidaciones.isLoadingDetalleRetenciones,
});

export default connect(mapStateToProps, {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
    resetLiquidaciones,
    fetchResultadosLiquidaciones,
    updateLiquidaciones,
    putConfirmarLiquidacion,
    updateEstadoLiquidacion,
    limpiarLiquidacionesBusqueda,
    updateEstadoListLiquidacion,
    fetchDetalleRetenciones,
    resetPercepcionRetencionLiquidacion,
    fetchCalcularPercepcionRetencion,
    actualizarTotalRetencionesOrdenes
})(EditarLiquidacionBorradorWrapper);
